import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';

import classes from './Alert.module.css';
import parse from 'html-react-parser';

//accessibility
//using portals to move backdrop content outside the content root element
const AlertBackdrop = ({onConfirm}) =>{
  return(
    <div className={classes.backdrop} onClick={onConfirm} />
  )
}

//using portals to move overlay content outside the content root element
const AlertModalOverlay = ({ onConfirm, title, message, onCancel, confirmLabel }) => {

  return(


    <div className = { classes.alert }>

      <div className = { classes.alertContent } >

      <div className= { classes.alertHeader }>  {title}  </div>

      <div className={classes.alertText}>

        {message && parse(message)}
        
      </div>

      <div className={classes.alertFooter}>

        {onCancel &&
          <button className={classes.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        }

        <button className={classes.confirmBtn} onClick={onConfirm}>
          {confirmLabel || 'OK'}
        </button>

      </div>

      </div>

    </div>



   
  )
}

const Alert = ( { onConfirm, title,  message, onCancel, confirmLabel  } ) => {
  return (
    <Fragment>

      {ReactDOM.createPortal(
        <AlertBackdrop
        onConfirm={onConfirm}
        />,
        document.getElementById('root-backdrop')
      )}

      {ReactDOM.createPortal(
        <AlertModalOverlay
        title={title}
        onConfirm={onConfirm}
        onCancel={onCancel}
        message={message}
        confirmLabel={confirmLabel}
        />,
        document.getElementById('root-overlay')
      )}
    </Fragment>
  );
};

export default Alert;
